<script lang="ts">
    import {getLocalization} from 'src/core';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {get} from 'svelte/store';
    import {exists} from 'shared/utils/custom-utils';
    import {callCommand} from '@milkdown/utils';
    import {toggleEmphasisCommand} from '@milkdown/preset-commonmark';
    import ToolbarButton from './ToolbarButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();

    function toggleItalic() {
        const editor = get(editor$);
        if (!exists(editor)) {
            return;
        }

        editor.action(
            callCommand(toggleEmphasisCommand.key)
        );
    }
</script>

<ToolbarButton icon="italic"
               tooltipLabel={localize(/* @kp-localization richTextArea.tools.italic */ 'richTextArea.tools.italic')}
               on:click={toggleItalic}/>